import React, { useState } from "react";
import { setToken, clearToken } from '../../utils/reducers/authSlice';
import { useDispatch, useSelector } from 'react-redux'
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AuthLayout from "../../layouts/AuthLayout";
import { useNavigate } from "react-router-dom";
import { LOGIN_API_URL } from "../../utils/Constant";

function LoginPage() {
  const dispatch = useDispatch();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const authToken = useSelector((state) => state.token);
  // if (authToken && authToken.token) {
  //   navigate("/login");
  // }

  const showToast = (loading, message, type) => {
    toast[type](
      <div>
        {loading} {message}
      </div>,
      {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 2000, // milliseconds
      }
    );
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      showToast(true, "Please fill in all required fields", "error");
      setLoading(false);
      return;
    }

    try {
      //showToast(true, "In Progress. Please wait..", "info");
      setLoading(true);
      let data = {
        email: email,
        password: password,
      };
      const response = await fetch(LOGIN_API_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
        credentials: 'include',
      });

      const result = await response.json();
      const token = result?.data?.token;
      const user_id = result?.data?.user_id;
      const username = result?.data?.username;
      const usertokenData = {
        "token": token,
        "user_id": user_id,
        "username": username
      }
      if (response.ok && token) {
        setLoading(false);
        dispatch(setToken(usertokenData));
        showToast(true, result.msg, "success");
        navigate('/');
      } else {
        dispatch(clearToken());
        setLoading(false);
        showToast(true, result.error, "error");
        console.error('Login failed or error during login');
      }
    } catch (error) {
      dispatch(clearToken());
      setLoading(false);
      console.error('Error during login:', error.message);
    }
  };

  return (
    <AuthLayout>
       {loading && (
          <div className="overlay">
            <div
              class="spinner-border text-danger"
              style={{ width: "5rem", height: "5rem" }}
              role="status"
            >
              <span class="sr-only">Loading...</span>
            </div>
          </div>
        )}
      <div className="login-box" >
        
        <div className="login-logo">
          <img
            src="https://mototrad.com/assets/dist/img/mototrad-logo-cropped.jpg"
            alt="Mototrad Logo"
            className="brand-image"
            style={{ "height": "70px" }}
          />
        </div>
        <div className="card">
          <div className="card-body login-card-body">
            {/* <p className="login-box-msg"><b>Login</b></p> */}
            <form action="" method="post" >
              <div className="input-group mb-3">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Email / Username"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value.toLowerCase())} />
                <div className="input-group-append">
                  <div className="input-group-text">
                    <span className="fas fa-envelope"></span>
                  </div>
                </div>
              </div>
              <div className="input-group mb-3">
                <input
                  type="password"
                  className="form-control"
                  placeholder="Password"
                  name="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <div className="input-group-append">
                  <div className="input-group-text">
                    <span className="fas fa-lock"></span>
                  </div>
                </div>
              </div>
              <div className="row">
                {/* <div className="col-8">
                  <div className="icheck-primary">
                    <input type="checkbox" id="remember" />
                    <label htmlFor="remember"> Remember Me </label>
                  </div>
                </div> */}
                <div className="col-12">
                  <button
                    type="submit"
                    className="btn btn-primary btn-block login-btn"
                    disabled={loading}
                    onClick={handleLogin}
                  >
                    {loading ? "Signing In" : "Sign In"}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </AuthLayout>
  );
}

export default LoginPage;
